import styled from 'styled-components';
import { colors } from '../../../../../assets/styles/GlobalStyles';

export const TaxCard = styled.div`
  background: linear-gradient(135deg, ${colors.blueDark} 0%, ${colors.blueMedium} 100%);
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  color: white;

  @media (max-width: 768px) {
    padding: 1.1rem;
  }
`;

export const TaxTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 1.05rem;
  }
`;

export const TaxValue = styled.div`
  font-size: 2rem;
  font-weight: 700;
  margin: 1rem 0;

  small {
    font-size: 0.9rem;
    font-weight: normal;
  }

  @media (max-width: 768px) {
    font-size: 1.6rem;
  }
`;

export const TaxInfo = styled.p`
  font-size: 0.8rem;
  opacity: 0.9;
  margin: 0;
`;

export const BoletoBox = styled.div`
  background: #f8fafc;
  border: 1px solid ${colors.borderLight};
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;

  @media (max-width: 768px) {
    padding: 1.1rem;
  }
`;

export const BoletoIcon = styled.div`
  font-size: 3rem;
  color: ${colors.lightBlue};
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 2.25rem;
  }
`;

export const BoletoTitle = styled.h4`
  color: ${colors.darkBlue};
  margin-bottom: 0.5rem;
`;

export const BoletoText = styled.p`
  color: ${colors.textMuted};
  font-size: 0.875rem;
  margin-bottom: 1rem;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const InfoMessage = styled.div`
  background: #e0f2fe;
  color: #0369a1;
  padding: 0.75rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  svg {
    flex-shrink: 0;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 1rem;
`;

export const RadioGroup = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  color: ${colors.darkGray};
`;

export const Radio = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: ${colors.darkBlue};
`;